<template>
    <div class="l-inner">
        <app-section
            :title="page.title"
            :desc="page.desc"
            :push="page.push"
            :logo="logo"
            :logoBottom="logoBottom"
            bgIntro="bright"
            ref="section"
        >
            <template #content>
                <div class="p-economies__grid | l-grid">
                    <app-section
                        v-for="(item, i) in economies"
                        :key="`item-${i}`"
                        tag='article'
                        :bgs="1"
                        class="o-economy"
                    >
                        <template #content>
                            <div class="o-economy__inner">
                                <card
                                    v-if="item.data.card_image || item.data.image"
                                    modifier="economy-img"
                                    :bg="i % 2 === 0 ? 'bright' : 'dark'"
                                >
                                    <template #inner>
                                        <asset
                                            :image="item.data.card_image ? item.data.card_image : item.data.image"
                                            class="c-card__picture"
                                        />
                                    </template>
                                </card>

                                <div class="o-economy__content | t-content">
                                    <h3
                                        v-if="item.data.title !== ''"
                                        class="t-t2-heavy | u-c-bright"
                                    >
                                        {{ item.data.title }}
                                    </h3>

                                    <prismic-rich-text
                                        v-if="item.data.desc"
                                        :field="item.data.desc"
                                    />

                                    <a
                                        v-if="item.data.website"
                                        :href="item.data.website.url"
                                        :title="title"
                                        class="o-place__website"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        {{ getWebsiteName(item.data.website) }}
                                    </a>

                                    <btn
                                        tag="router-link"
                                        :label="`${$t('btn.discover')}${item.data.title.toLowerCase()}`"
                                        :href="`/economies/${item.uid}`"
                                        iconAfter="arrow-right"
                                        :small="true"
                                        color="bright"
                                    />
                                </div>
                            </div>
                        </template>
                    </app-section>
                </div>
            </template>
        </app-section>
        <about />
        <push :page="page.page_push" />
    </div>
</template>

<script>

import Push from 'layout/Push';
import About from 'layout/About';
import AppSection from 'layout/AppSection';
import Icon from 'objects/Icon';
import Asset from 'objects/Asset';
import AnimText from 'objects/AnimText';
import PrismicRichText from 'objects/PrismicRichText';
import Btn from 'components/Btn';
import Card from 'components/Card';

import Variables from 'src/mixins/variables';

export default {
    name: 'Economies',
    components: {
        Push,
        About,
        AppSection,
        Icon,
        Asset,
        AnimText,
        PrismicRichText,
        Btn,
        Card,
    },
    mixins: [ Variables ],
    props: {
        page: Object,
    },
    data: () => ({
        imageSize: 480,
        logo: false,
        logoBottom: false,
    }),
    mounted() {
        this.setLogo(false)
    },
    computed: {
        economies() {
            return this.$store.getters['global/getPageByHandle']('economy')
        },
    },
    methods: {
        setLogo(autoplay=true) {
            this.logoBottom = this.isHorizontal
            this.logo = !this.isHorizontal

            this.$nextTick(() => {
                this.$refs.section.setAnimation(true)
            })
        },
        getWebsiteName(website) {
            if(!website) {
                return
            }

            return website.url.replace(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?/i, "").split('/')[0]
        },
        getSrcset(image) {
            const img1 = `${image.url}?w=${this.imageSize}&dpr=1`;
            const img2 = `${image.url}?w=${this.imageSize * 2}&dpr=2`;
            const img3 = `${image.url}?w=${this.imageSize * 3}&dpr=3`;
            return `${img1} ${this.imageSize}w, ${img2} ${this.imageSize * 2}w, ${img3} ${this.imageSize * 3}w`
        },

        viewBgIntro(e) {
            gsap.to(e.target, {
                duration: .4,
                scaleX: this.ifHorizontal(`${1 + e.percent.center.x/10}px`, 1),
                scaleY: this.ifHorizontal(1, `${1 + e.percent.top/5}px`),
                ease: 'sine.out',
            })
        },
    },
    watch: {
        isHorizontal(horizontal) {
            this.setLogo()
        },
    },
};
</script>

<style lang="scss">

.p-economies__grid {

    @media #{$breakpoint-vertical} {

        &.-economies {
            margin-top: 0;
        }
    }
}



/*========================================
=            Economy sections            =
========================================*/


.o-economy {

    .l-section__bg {
        right: -12%;
        width: 30%;
        --color-bg: #{$color-bright};
    }

    &:nth-child(even) {

        .l-section__bg {
            --color-bg: #{$color-dark};
        }
    }

    @media (min-width: #{2 * $card-max-width}) {
        margin-top: 0 !important;
    }

    @media #{$breakpoint-vertical} {

        &:nth-child(even) {

            .c-card {
                margin-left: auto;
            }
        }

        .l-section__bg {
            display: none;
        }

        .c-card {
            max-width: 28em;
        }
    }

    @media #{$breakpoint-horizontal} {

        &:nth-child(even) {

            .o-economy__inner {
                flex-direction: column-reverse;
            }
        }
    }
}

.o-economy__inner {
    z-index: 1;

    @media #{$breakpoint-horizontal} {
        display: flex;
        flex-direction: column;

        width: 80vw;
        height: 100%;

        .o-economy__content {
            padding: 5% 8%;
            width: calc(3/4 * 100%);
            margin-top: auto;
            margin-bottom: auto;
        }
    }
}

.o-economy__content {
    padding: 2em 1em;

    @media #{md("xs")} {
        padding: 2.5em 1.5em;
    }

    @media #{$breakpoint-vertical} {
        max-width: 32em;
        margin-right: auto;
        margin-left: auto;
    }
}


</style>
